import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Grid} from '@mui/material'
import {makeStyles} from '@mui/styles'
import {Spacing, Colors} from '../../assets/styles'
import {borderRadiusMedium} from '../../assets/styles/border'
import DataComingSoon from '../DataComingSoon'
import ReasonForLeavingHorizontalBarChart from './ReasonForLeavingHorizontalBarChart'
import {totalSelections} from './exitSurveyReasonData'

const WINDOW_OPTIONS = [
  {label: '30 day', key: 'thirtyDay'},
  {label: '6 month', key: 'sixMonth'},
]
const WINDOW_LABELS = WINDOW_OPTIONS.map(o => o.label)

/**
 * @param {Object} props
 * @param {{thirtyDay: import('./exitSurveyReasonData').ReasonBreakdown, sixMonth: import('./exitSurveyReasonData').ReasonBreakdown}} props.breakdownByWindow
 */
function ReasonForLeavingChart({breakdownByWindow}) {
  const classes = useStyles()

  const [windowIndex, setWindowIndex] = useState(0)

  const breakdown = breakdownByWindow[WINDOW_OPTIONS[windowIndex].key]
  const hasData = totalSelections(breakdown) > 0

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {!hasData ? (
          <div className={classes.section}>
            <DataComingSoon />
          </div>
        ) : (
          <ReasonForLeavingHorizontalBarChart
            breakdown={breakdown}
            windowLabels={WINDOW_LABELS}
            windowIndex={windowIndex}
            onWindowChange={setWindowIndex}
          />
        )}
      </Grid>
    </Grid>
  )
}

ReasonForLeavingChart.propTypes = {
  breakdownByWindow: PropTypes.shape({
    thirtyDay: PropTypes.object,
    sixMonth: PropTypes.object,
  }).isRequired,
}

const useStyles = makeStyles({
  section: {
    marginBottom: Spacing.spaceMedium,
    padding: Spacing.spaceMedium,
    backgroundColor: Colors.rxrWhiteColor,
    border: `1px solid ${Colors.rxrGreyColor}`,
    borderRadius: borderRadiusMedium,
    boxShadow: Colors.shadowSoft,
  },
})

export default ReasonForLeavingChart
